import { BasicFrame } from 'components/organisms';
import { Button, Card, Link, Spacer, Text, Title } from 'components';
import { frameConfigBasic } from '../../AppConfig';
import { getScreenTranslation } from '../../utils/translations';
import { PAYLAND_SEARCHPARAM_CONTINUE } from '../../hooks/usePayment';
import { ROUTES } from 'utils/constants/constants_routes';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { WarningYellowIcon } from 'components/icons';
import classes from 'classnames';
import layout from 'scss/layout.module.scss';
import React from 'react';
import styles from './PaylandFailed.module.scss';

export default function PaymentFailed() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const i18Next = useTranslation();

  const content = getScreenTranslation('paylandFailed', i18Next);

  const onPrimaryBtnHandler = () => {
    navigate(
      searchParams.get(PAYLAND_SEARCHPARAM_CONTINUE) ||
        ROUTES.FIRST_LOAN_WELCOME,
    );
  };

  const onSecondaryBtnHandler = () => {};

  return (
    <BasicFrame
      {...frameConfigBasic}
      headerLayout="centered"
      footerLayout="default"
      contentWrapperClassName={layout['width-md']}
    >
      <Card
        className={classes([styles.container])}
        dataTest="paymentFailed-card"
      >
        <Title
          className={classes([styles.title])}
          icon={<WarningYellowIcon />}
          text={content.title}
          forceColumn
        />
        <Spacer marginTop="30px">
          <Text
            className={styles['helper-text']}
            dataTest="paymentFailed-helper-text"
            dangerouslySetInnerHTML={{ __html: content.body }}
          />
        </Spacer>
        <Spacer
          marginTop={{ default: '50px', xs: '40px' }}
          className={styles['button-wrapper']}
        >
          <Button
            className={layout['width-sm']}
            onClick={onPrimaryBtnHandler}
            dataTest="continue-btn"
          >
            {content.primaryBtn}
          </Button>
        </Spacer>
        {onSecondaryBtnHandler && (
          <Spacer marginTop="20px">
            <Link
              className={styles.bold}
              onClick={onSecondaryBtnHandler}
              dataTest={'paymentFailed-secondary-btn'}
            >
              {content.secondaryBtn}
            </Link>
          </Spacer>
        )}
      </Card>
    </BasicFrame>
  );
}
